import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const en = {
  profile: {
    ContactInfo: "Contact Info",
  },
};

const ar = {
  profile: {
    ContactInfo: "Contact Info",
  },
};

const he = {
  profile: {
    ContactInfo: "Contact Info",
  },
};

const resources = {
  en: {
    translation: en,
  },

  ar: {
    translation: ar,
  },
  he: {
    translation: he,
  },
};
i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
